class GiPromoInset extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.isInitialized = false;
    this.autoplayButton = null;
    this.handleAutoplayButtonClick = this.handleAutoplayButtonClick.bind(this);
  }

  connectedCallback() {
    if (this.isInitialized) return;

    const swiperElement = this.querySelector('.swiper');
    this.autoplayButton = this.querySelector('.gi-promo-inset__autoplay-button');

    if (!swiperElement) return;

    this.initSwiper(swiperElement);
    this.initEvents();

    this.isInitialized = true;
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
      this.autoplayButton?.removeEventListener('click', this.handleAutoplayButtonClick);
      this.isInitialized = false;
    }
  }

  initSwiper(swiperElement) {
    this.swiper = new Swiper(swiperElement, {
      speed: 300,
      loop: true,
      slidesPerView: 1,
      autoplay: {
        delay: 3000,
      }
    });
  }

  initEvents() {
    this.autoplayButton?.addEventListener('click', this.handleAutoplayButtonClick);
  }

  handleAutoplayButtonClick() {
    if (this.swiper.autoplay.running) {
      this.swiper.autoplay.stop();
      this.autoplayButton.classList.remove('is-playing');
    } else {
      this.swiper.autoplay.start();
      this.autoplayButton.classList.add('is-playing');
    }
  }
}

customElements.define('gi-promo-inset', GiPromoInset);
